import {
  Button,
  Chip,
  FormControl,
  Grid,
  InputAdornment,
  OutlinedInput,
  TextField,
  MenuItem,
  InputLabel,
  makeStyles,
  useTheme,
  Select,
  Tooltip,
  IconButton,
} from "@material-ui/core";
import React, { useEffect, useState, useRef, useCallback } from "react";
import SwipeableViews from "react-swipeable-views";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import PropTypes from "prop-types";
import { FilterAutoComplete } from "../../../../components/common/FilterLayout/GridFilter";
import { useDispatch, useSelector } from "react-redux";
import EmptyTextarea from "../../../../components/common/Textarea";
// Require Editor JS files.
import "froala-editor/js/froala_editor.pkgd.min.js";
import "froala-editor/js/plugins.pkgd.min.js";
import "froala-editor/js/third_party/embedly.min.js";
// Require Editor CSS files.
import "froala-editor/css/froala_style.min.css";
import "froala-editor/css/froala_editor.pkgd.min.css";
import "froala-editor/css/third_party/embedly.min.css";
import FroalaEditor from "react-froala-wysiwyg";
import Froalaeditor from "froala-editor";
import { launchesActions } from "../../../../store/launches/launchesActions";
import CustomCheckbox from "../../../../components/common/checkbox/CustomCheckbox";
import { C } from "@fullcalendar/core/internal-common";
import { conversationAction } from "../../../../store/conversations/conversationAction";
import { AttachFile, Close, InsertDriveFile, Image } from "@material-ui/icons";

const useStyles = makeStyles(theme => ({
  form: {
    padding: "0px 15px",
  },
  emailInput: {
    marginTop: "10px",
    width: "100%",
    "& .MuiInputBase-input": {
      border: "unset !important",
    },
  },
  subjectInput: {
    width: "100%",
    "& .MuiInputBase-input": {
      border: "unset !important",
    },
  },
  usersButtonGroup: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    margin: "10px 0px",
    gap: "8px",
  },
  activeBtn: {
    background: "#3699FF",
    color: "#fff",
    padding: "5px 20px",
    border: "1px solid #3699FF",
    borderRadius: "6px",
    textTransform: "capitalize",
    "&:hover": {
      background: "#3699FF",
    },
  },
  usersBtn: {
    background: "none",
    color: "#3699FF",
    padding: "5px 20px",
    border: "1px solid #3699FF",
    borderRadius: "6px",
    textTransform: "capitalize",
    "&:hover": {
      background: "#none",
    },
  },
  tagHeading: {
    color: "#3F4254",
    fontFamily: "Roboto",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: "12px",
  },
  tagsHeadings: {
    color: "#2d3339",
    fontSize: "14px",
    fontWeight: "500",
  },
  chip: {
    margin: theme.spacing(0.5),
    backgroundColor: "#F3F6F9",
    color: "#70808F",
    fontFamily: "Roboto",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: "145%",
  },
  noTagText: {
    color: "#70808F",
    textAlign: "center",
    fontFamily: "Roboto",
    fontSize: "12px",
    fontStyle: "italic",
    fontWeight: "500",
    lineHeight: "12px",
    marginTop: "8px",
  },
  tagBox: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "start",
    marginBottom: "10px",
    maxHeight: "40px",
    overflowY: "auto",
  },
  tagsHeadings: {
    color: "#2d3339",
    fontSize: "14px",
    fontWeight: "500",
  },
  contentBox: {
    "& textarea": {
      height: "120px !important",
      minHeight: "120px !important",
    },
  },
  notFoundText: {
    textAlign: "center",
    opacity: 0.5,
    fontSize: "12px",
    fontWeight: 500,
    marginBottom: "10px",
  },
  chipsContainer: {
    height: "300px",
    overflowY: "auto",
  },
  showMore: {
    margin: theme.spacing(0.5),
    backgroundColor: "#3699FF",
    color: "#fff !important",
    fontFamily: "Roboto",
    fontSize: "12px !important",
    fontStyle: "normal",
    lineHeight: "145%",
    padding: "7px",
    borderRadius: "20px",
    cursor: "pointer",
  },
  showMoreBox: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  FrolaEditor: {
    marginTop: "10px",
    "& .fr-popup": {
      left: "200px !important",
      zIndex: "999999999999999 !important",
    },
    "& .fr-basic": {
      maxHeight: "300px",
    },
    "& .fr-wrapper": {
      height: "120px",
      overflowY: "auto",
    },
    '& [title="Insert Files"]': {
      display: "none",
    },
  },
  customeCheckbox: {
    position: "absolute !important",
    left: "4px",
    top: "5px",
  },
  checkBoxInput: {
    width: "20px",
    height: "20px",
  },
  filterAutoComplete: {
    "& .countLabel": {
      right: "25px !important",
      top: "4px !important",
      width: "25px !important",
      height: "25px !important",
      color: "#fff !important",
    },
    "& .MuiAutocomplete-input": {
      padding: "4px 4px 4px 25px !important",
    },
  },
  templateDropdown: {
    marginBottom: "15px",
    "& .MuiOutlinedInput-root": {
      height: "50px",
      "& .MuiSelect-select": {
        display: "flex",
        alignItems: "center",
      },
    },
    "& .MuiInputLabel-outlined": {
      transform: "translate(14px, 16px) scale(1)",
    },
    "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
      transform: "translate(14px, -6px) scale(0.75)",
    },
  },
  templateSelect: {
    flex: 1,
    fontSize: "14px",
    background: "transparent",
    "&:before, &:after": {
      display: "none",
    },
    "& .MuiInputBase-input": {
      border: "none !important",
    },
    padding: "8px 0",
  },
  // Attachment styles
  attachmentSection: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    margin: "15px 0",
    flexWrap: "wrap",
    gap: "10px",
  },
  attachmentHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    marginBottom: "10px",
  },
  attachmentTitle: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    color: "#333333",
    fontWeight: 500,
    fontSize: "14px",
  },
  addAttachmentBtn: {
    color: "#3699ff",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: "4px",
    fontSize: "13px",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  attachmentsContainer: {
    display: "flex",
    flexWrap: "wrap",
    gap: "12px",
    marginTop: "5px",
    width: "100%",
  },
  attachmentItem: {
    position: "relative",
    width: "100px",
    height: "100px",
    border: "1px solid #e0e0e0",
    borderRadius: "8px",
    overflow: "hidden",
    cursor: "pointer",
    "&:hover $removeAttachment": {
      display: "flex",
    },
  },
  attachmentImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  fileIconContainer: {
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#f5f5f5",
    color: "#666",
    fontSize: "12px",
    textAlign: "center",
    padding: "5px",
  },
  fileIcon: {
    fontSize: "40px",
    color: "#3699ff",
    marginBottom: "5px",
  },
  fileName: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    maxWidth: "90px",
    fontSize: "11px",
  },
  removeAttachment: {
    position: "absolute",
    top: "2px",
    right: "2px",
    backgroundColor: "rgba(255, 255, 255, 0.9)",
    borderRadius: "50%",
    width: "20px",
    height: "20px",
    display: "none",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    color: "#f44336",
    "&:hover": {
      backgroundColor: "#fff",
    },
  },
  hiddenFileInput: {
    display: "none",
  },
}));

new FroalaEditor(".selector", {
  toolbarButtons: {
    moreText: {
      buttons: [
        "bold",
        "italic",
        "underline",
        "strikeThrough",
        "subscript",
        "superscript",
        "fontFamily",
        "fontSize",
        "textColor",
        "backgroundColor",
        "inlineClass",
        "inlineStyle",
        "clearFormatting",
      ],
    },
    moreParagraph: {
      buttons: [
        "alignLeft",
        "alignRight",
        "alignJustify",
        "formatOLSimple",
        "formatOL",
        "formatUL",
        "paragraphFormat",
        "paragraphStyle",
        "lineHeight",
        "outdent",
        "indent",
        "quote",
      ],
    },
    moreRich: {
      buttons: [
        "insertLink",
        "insertImage",
        "insertTable",
        "emoticons",
        "fontAwesome",
        "specialCharacters",
        "embedly",
      ],
    },
    moreMisc: {
      buttons: ["undo", "redo", "spellChecker", "selectAll", "html", "help"],
      align: "right",
      buttonsVisible: 2,
    },
  },
  inlineClasses: {
    "fr-popup": "custom",
  },
});

const NewCompaignForm = ({
  open,
  endUserCampaign,
  setEndUserCampaign,
  businessCustomerCampaign,
  setBusinessCustomerCampaign,
  leadCampaign,
  setLeadCampaign,
  model,
  setModel,
  subject,
  setSubject,
  isSupportInbox,
  emailTemplates = [],
  selectedTemplateId,
  onTemplateSelect,
  // New props for attachments
  attachments = [],
  onAttachmentsChange,
  showAttachments = true,
}) => {
  const classes = useStyles();
  const theme = useTheme();
  const dispatch = useDispatch();
  const fileInputRef = useRef(null);
  var test = "";

  useEffect(() => {
    // This ensures the form fields are in sync with parent component
  }, [model, subject]);

  const {
    leadCampaignsData,
    endUserCampaignsData,
    businessCustomersCampaignsData,
  } = useSelector(state => state.LaunchesReducer);
  const [activeButton, setActiveButton] = useState(1);
  const [checkedState, setCheckedState] = useState({
    allEndUser: false,
    allBusinessUser: false,
    allLeads: false,
  });

  useEffect(() => {
    setCheckedState({
      allEndUser: endUserCampaignsData.length === endUserCampaign?.length,
      allBusinessUser:
        businessCustomersCampaignsData.length ===
        businessCustomerCampaign?.length,
      allLeads: leadCampaignsData?.length === leadCampaign.length,
    });
  }, [
    endUserCampaignsData,
    endUserCampaign,
    businessCustomersCampaignsData,
    businessCustomerCampaign,
    leadCampaignsData,
    leadCampaign,
  ]);

  const handleCheckboxChange = event => {
    const { name, checked } = event.target;
    if (checked) {
      if (name === "allEndUser") {
        setEndUserCampaign(endUserCampaignsData);
      } else if (name === "allBusinessUser") {
        setBusinessCustomerCampaign(businessCustomersCampaignsData);
      } else if (name === "allLeads") {
        setLeadCampaign(leadCampaignsData);
      }
    } else {
      if (name === "allEndUser") {
        setEndUserCampaign([]);
      } else if (name === "allBusinessUser") {
        setBusinessCustomerCampaign([]);
      } else if (name === "allLeads") {
        setLeadCampaign([]);
      }
    }
  };
  const handleChangeIndex = index => {
    setActiveButton(index);
  };

  const onHandleModelChange = model => {
    console.log("============>>>>", model);
    let removedEntities = model?.replace(/&nbsp;/g, " ");
    let withoutTags = removedEntities?.replace(/<(?!img\b)[^>]*>/g, "");
    let cleanedStr = withoutTags?.replace(/\s+/g, "").trim();
    if (cleanedStr?.length > 0) {
      setModel(model);
    } else {
      setModel("");
    }
  };

  const uploadFroalaImage = file => {
    dispatch(launchesActions.uploadImage(file)).then(res => {
      if (res.success) {
        test = res.data.url;
      }
    });
  };

  const uploadChatFroalaImage = file => {
    dispatch(conversationAction.onUploadFile(file)).then(res => {
      if (res?.responseCode === 1) {
        test = res?.responseData?.url;
      }
    });
  };

  const handleEndUserDelete = id => {
    setEndUserCampaign(prevCampaigns =>
      prevCampaigns.filter(campaign => campaign.id !== id),
    );
  };

  const handleBusinessUserDelete = id => {
    setBusinessCustomerCampaign(prevCampaigns =>
      prevCampaigns.filter(campaign => campaign.id !== id),
    );
  };

  const handleLeadDelete = id => {
    setLeadCampaign(prevCampaigns =>
      prevCampaigns.filter(campaign => campaign.id !== id),
    );
  };

  function truncate(campaign) {
    if (campaign && campaign.length > 100) {
      return campaign.substring(0, 95) + "...";
    }
    return campaign;
  }

  // Native file input handler
  const handleFileSelect = event => {
    const files = Array.from(event.target.files);

    files.forEach(file => {
      const fileUrl = URL.createObjectURL(file);
      const fileType = file.type;
      const isImage = fileType.startsWith("image/");

      const newAttachment = {
        id: Date.now() + Math.random(),
        file: file,
        name: file.name,
        url: fileUrl,
        type: fileType,
        isImage: isImage,
        size: file.size,
      };
      if (onAttachmentsChange) {
        onAttachmentsChange([...attachments, newAttachment]);
      }
    });

    // Reset file input so the same file can be selected again
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const handleRemoveAttachment = useCallback(
    attachmentId => {
      if (onAttachmentsChange) {
        const updatedAttachments = attachments.filter(
          a => a.id !== attachmentId,
        );
        const removedAttachment = attachments.find(a => a.id === attachmentId);
        if (removedAttachment?.url) {
          URL.revokeObjectURL(removedAttachment.url);
        }
        onAttachmentsChange(updatedAttachments);
      }
    },
    [attachments, onAttachmentsChange],
  );

  // Format file size
  const formatFileSize = bytes => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const sizes = ["Bytes", "KB", "MB", "GB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
  };

  return (
    <Grid className={classes.form}>
      {/* Template Selector */}
      {open?.platform !== "Facebook" &&
        open?.platform !== "Instagram" &&
        open !== true &&
        emailTemplates.length > 0 && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "10px",
              border: "1px solid rgba(0, 0, 0, 0.23)",
              borderRadius: "4px",
              padding: "0 14px",
              height: "40px",
              position: "relative",
            }}>
            <span
              style={{
                marginRight: "8px",
                color: "rgba(0, 0, 0, 0.54)",
                fontSize: "14px",
                whiteSpace: "nowrap",
              }}>
              Email Template :
            </span>
            <Select
              value={selectedTemplateId || ""}
              onChange={e => onTemplateSelect(e.target.value)}
              displayEmpty
              variant='standard'
              disableUnderline
              className={classes.templateSelect}
              MenuProps={{
                PaperProps: {
                  style: {
                    maxHeight: 300,
                  },
                },
              }}>
              <MenuItem value='' style={{ color: "rgba(0, 0, 0, 0.54)" }}>
                <em>Select Template</em>
              </MenuItem>
              {emailTemplates.map(template => (
                <MenuItem key={template.id} value={template.id}>
                  {template.templateName}
                </MenuItem>
              ))}
            </Select>
          </div>
        )}

      {/* Subject Field */}
      {open?.platform !== "Facebook" && open?.platform !== "Instagram" && (
        <FormControl className={classes.subjectInput} variant='outlined'>
          <OutlinedInput
            id='outlined-adornment-weight'
            startAdornment={
              <InputAdornment position='start'>Subject : </InputAdornment>
            }
            aria-describedby='outlined-weight-helper-text'
            value={isSupportInbox ? open?.subject : subject}
            onChange={e => {
              if (!e.target.value.trim()) {
                setSubject("");
              } else if (e.target.value.length <= 100) {
                setSubject(e.target.value);
              }
            }}
          />
        </FormControl>
      )}

      {/* User Selection Tabs */}
      {open === true && (
        <Grid className={classes.usersButtonGroup}>
          <Button
            className={
              activeButton === 1 ? classes.activeBtn : classes.usersBtn
            }
            onClick={() => setActiveButton(1)}>
            End Users
          </Button>
          <Button
            className={
              activeButton === 2 ? classes.activeBtn : classes.usersBtn
            }
            onClick={() => setActiveButton(2)}>
            Business Users
          </Button>
          <Button
            className={
              activeButton === 3 ? classes.activeBtn : classes.usersBtn
            }
            onClick={() => setActiveButton(3)}>
            Leads
          </Button>
        </Grid>
      )}

      {/* Email/User Display */}
      <div>
        {open !== true ? (
          <FormControl className={classes.emailInput} variant='outlined'>
            <OutlinedInput
              id='outlined-adornment-weight'
              startAdornment={
                <InputAdornment position='start'>Email : </InputAdornment>
              }
              aria-describedby='outlined-weight-helper-text'
              value={isSupportInbox ? open.fromEmail : open?.email}
              readOnly
            />
          </FormControl>
        ) : (
          <div>
            {activeButton === 1 && (
              <div
                className={`userDetailsSearchField inputWrapper filterSelect ${classes.filterAutoComplete}`}>
                <FilterAutoComplete
                  value={endUserCampaign}
                  onChange={(event, value) => {
                    setEndUserCampaign(value);
                  }}
                  id='product-type-dd'
                  options={endUserCampaignsData}
                  getOptionLabel={option =>
                    truncate(`${option?.email} -  ${option?.fullName}`) || ""
                  }
                  placeholder={"End User"}
                  selectedFilter={
                    endUserCampaign?.length > 99
                      ? "+99"
                      : endUserCampaign?.length
                  }
                />
                <span className={`${classes.customeCheckbox} dateCheckbox`}>
                  <input
                    type='checkbox'
                    className={classes.checkBoxInput}
                    name='allEndUser'
                    checked={checkedState.allEndUser}
                    onChange={handleCheckboxChange}
                  />
                </span>
                <div>
                  <h2 className={classes.tagsHeadings}> End User </h2>
                  <UsersChips
                    chipdata={endUserCampaign}
                    notFoundMessage={"No End User Added"}
                    handleDelete={handleEndUserDelete}
                  />
                </div>
              </div>
            )}
            {activeButton === 2 && (
              <div
                className={`userDetailsSearchField inputWrapper filterSelect ${classes.filterAutoComplete}`}>
                <FilterAutoComplete
                  value={businessCustomerCampaign}
                  onChange={(event, value) => {
                    setBusinessCustomerCampaign(value);
                  }}
                  id='product-type-dd'
                  options={businessCustomersCampaignsData}
                  getOptionLabel={option =>
                    truncate(`${option?.email} -  ${option?.fullName}`) || ""
                  }
                  placeholder={"Business User"}
                  selectedFilter={
                    businessCustomerCampaign?.length > 99
                      ? "+99"
                      : businessCustomerCampaign?.length
                  }
                />
                <span className={`${classes.customeCheckbox} dateCheckbox`}>
                  <input
                    type='checkbox'
                    className={classes.checkBoxInput}
                    name='allBusinessUser'
                    checked={checkedState.allBusinessUser}
                    onChange={handleCheckboxChange}
                  />
                </span>
                <div>
                  <h2 className={classes.tagsHeadings}> Business User </h2>
                  <UsersChips
                    chipdata={businessCustomerCampaign}
                    notFoundMessage={"No Business User Added"}
                    handleDelete={handleBusinessUserDelete}
                  />
                </div>
              </div>
            )}
            {activeButton === 3 && (
              <div
                className={`userDetailsSearchField inputWrapper filterSelect ${classes.filterAutoComplete}`}>
                <FilterAutoComplete
                  value={leadCampaign}
                  onChange={(event, value) => {
                    setLeadCampaign(value);
                  }}
                  id='product-type-dd'
                  options={
                    leadCampaignsData?.data !== null ? leadCampaignsData : []
                  }
                  getOptionLabel={option =>
                    truncate(`${option?.email} -  ${option?.fullName}`) || ""
                  }
                  placeholder={"Lead"}
                  selectedFilter={
                    leadCampaign?.length > 99 ? "+99" : leadCampaign?.length
                  }
                />
                <span className={`${classes.customeCheckbox} dateCheckbox`}>
                  <input
                    type='checkbox'
                    className={classes.checkBoxInput}
                    name='allLeads'
                    checked={checkedState.allLeads}
                    onChange={handleCheckboxChange}
                  />
                </span>
                <div>
                  <h2 className={classes.tagsHeadings}> Leads </h2>
                  <UsersChips
                    chipdata={leadCampaign}
                    notFoundMessage={"No Lead Added"}
                    handleDelete={handleLeadDelete}
                  />
                </div>
              </div>
            )}
          </div>
        )}

        {/* Message/Email Body Editor */}
        {open?.platform === "Facebook" || open?.platform === "Instgram" ? (
          <EmptyTextarea
            placeholder='Enter message here'
            value={model}
            onChange={t => setModel(t.target.value)}
          />
        ) : (
          <div className={`${classes.FrolaEditor} fr-view`}>
            <FroalaEditor
              model={model}
              onModelChange={onHandleModelChange}
              tag='textarea'
              config={{
                toolbarButtons: [
                  ["bold", "italic", "underline", "strikeThrough"],
                  ["fontFamily", "fontSize", "textColor", "backgroundColor"],
                  ["alignLeft", "alignRight", "alignJustify"],
                  ["formatOL", "formatUL", "outdent", "indent"],
                  ["insertLink", "insertImage"],
                  ["emoticons", "specialCharacters"],
                  ["clearFormatting"],
                ],
                videoInsert: false,
                fileInsert: false,
                placeholderText:
                  open === true ? "Add Campaign Message..." : "Compose email",
                events: {
                  "image.inserted": function ($img, response) {
                    $img[0].src =
                      "https://logosbynick.com/wp-content/uploads/2021/01/animated-gif.gif";
                    setTimeout(() => {
                      $img[0].src = test;
                    }, 7000);
                    console.log(this);
                  },
                  "image.beforeUpload": function (images) {
                    if (isSupportInbox) {
                      uploadChatFroalaImage(images);
                    } else {
                      uploadFroalaImage(images);
                    }
                    console.log(this);
                  },
                },
                key: "VCC6kE4A3D3H3C7C7C6cWHNGGDTCWHIg1Ee1Oc2Yc1b1Lg1POkB6B5F5A3F3E3B3F2A5C3==",
              }}
            />
          </div>
        )}
      </div>

      {/* Native File Input Attachment Section */}
      {showAttachments && (
        <>
          {/* Hidden file input */}
          <input
            type='file'
            ref={fileInputRef}
            onChange={handleFileSelect}
            multiple={true}
            className={classes.hiddenFileInput}
            accept='image/*,.pdf,.doc,.docx'
          />

          <div className={classes.attachmentSection}>
            <div className={classes.attachmentHeader}>
              <div className={classes.attachmentTitle}>
                <AttachFile />
                <span>Attachments ({attachments.length})</span>
              </div>
              <div
                className={classes.addAttachmentBtn}
                onClick={() => fileInputRef.current?.click()}>
                <AttachFile fontSize='small' />
                Add Files
              </div>
            </div>

            {attachments.length > 0 && (
              <div className={classes.attachmentsContainer}>
                {attachments.map(attachment => (
                  <div key={attachment.id} className={classes.attachmentItem}>
                    {attachment.isImage ? (
                      <img
                        src={attachment.url}
                        alt={attachment.name}
                        className={classes.attachmentImage}
                        onClick={() => window.open(attachment.url, "_blank")}
                      />
                    ) : (
                      <div
                        className={classes.fileIconContainer}
                        onClick={() => window.open(attachment.url, "_blank")}>
                        <InsertDriveFile className={classes.fileIcon} />
                        <div className={classes.fileName}>
                          {attachment.name}
                        </div>
                        <div style={{ fontSize: "9px", color: "#999" }}>
                          {formatFileSize(attachment.size)}
                        </div>
                      </div>
                    )}
                    <Tooltip title='Remove'>
                      <div
                        className={classes.removeAttachment}
                        onClick={e => {
                          e.stopPropagation();
                          handleRemoveAttachment(attachment.id);
                        }}>
                        <Close fontSize='small' />
                      </div>
                    </Tooltip>
                  </div>
                ))}
              </div>
            )}
          </div>
        </>
      )}
    </Grid>
  );
};

export default NewCompaignForm;

const UsersChips = ({ chipdata = [], notFoundMessage, handleDelete }) => {
  const classes = useStyles();
  const [showMoreChips, setShowMoreChips] = useState(3);

  function truncate(campaign) {
    if (campaign && campaign.length > 35) {
      return campaign.substring(0, 33) + "...";
    }
    return campaign;
  }

  return (
    <div>
      {chipdata?.length ? (
        <div className={classes.tagBox}>
          {chipdata?.slice(0, showMoreChips).map(tag => (
            <Chip
              key={tag.id}
              label={truncate(tag.fullName)}
              onDelete={() => handleDelete(tag?.id)}
              className={classes.chip}
            />
          ))}
          <div className={classes.showMoreBox}>
            {chipdata?.length > 3 ? (
              showMoreChips === 3 ? (
                <div
                  style={{
                    color: "#fff",
                    fontWeight: "700",
                  }}
                  className={classes.showMore}
                  onClick={() => setShowMoreChips(chipdata?.length)}>
                  {`+ ${chipdata?.length - 3}`}
                </div>
              ) : (
                <div
                  style={{
                    color: "#fff !important",
                    fontWeight: "700",
                  }}
                  className={classes.showMore}
                  onClick={() => setShowMoreChips(3)}>
                  Show Less
                </div>
              )
            ) : null}
          </div>
        </div>
      ) : (
        <div className={classes.notFoundText}>{notFoundMessage}</div>
      )}
    </div>
  );
};
